module.exports = __webpack_public_path__ + "static/media/anti__bg__4.ff6c5e11.png";